import { Otoczenie } from './../ankieta';
import { KnaufPlaster } from './../knauf-plaster.enum';
import { ProjectService } from './../project.service';
import { Component, OnInit, signal } from '@angular/core';
import { Project } from '../project';
import { Plaster } from '../plaster';
import { PlasterService } from '../plaster.service';
import { ModalService } from '../modal.service';
import {MatAccordion, MatExpansionModule} from '@angular/material/expansion';

@Component({
  selector: 'app-questionnaire-summary',
  templateUrl: './questionnaire-summary.component.html',
  styleUrls: ['./questionnaire-summary.component.sass']
})
export class QuestionnaireSummaryComponent implements OnInit {
  next: string = "/calculator";
  prev: string = "/questionnaire4";
  project: Project
  plaster: Plaster;
  plasterReplacements: Plaster[] = [];
  Otoczenie = Otoczenie;
  step = signal(0);

  constructor(private projectService: ProjectService, private plasterService: PlasterService, private modalService: ModalService) { }

  ngOnInit() {
    this.project = this.projectService.getProject();
    this.plaster = this.plasterService.getKnaufPlaster(this.projectService.getSelectedKnaufPlaster());
    this.prev = this.project.ankieta.isQuestion4Required() ? "/questionnaire4" : "/questionnaire3";
    this.plaster.replacement.forEach((plaster) => {
      this.plasterReplacements.push(this.plasterService.getKnaufPlaster(plaster));
    });
    this.projectService.selectKnaufPlaster(this.plaster.knaufPlaster);
  }

  openModal(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }

  changePlaster(plaster: Plaster, id) {
    this.plaster = plaster;
    this.projectService.selectKnaufPlaster(this.plaster.knaufPlaster);
    this.plasterReplacements = [];
    this.plaster.replacement.forEach((plaster) => {
      this.plasterReplacements.push(this.plasterService.getKnaufPlaster(plaster));
    });
    this.modalService.close(id);
  }
}
